@if(doShow) {
<div class="aftersales">
	<div class="main">
		<div class="flow">{{appModeEnum[appState.appMode.value]}}</div>
		<div class="ticket">ticket&nbsp;{{appState.afterSalesCRMCaseNo.value}}</div>
		<div class="partner ellipsis">
			{{('CUSTOMERS.BAR.ORDER-FOR' | translate) + ' ' + customerName}}	
		</div>
	</div>
	<div class="abort">
		<button (click)="abortAfterSales()">{{ 'CUSTOMERS.BAR.ABORT' | translate }}</button>
	</div>
</div>
}
@else {
<div class="active-customer" [ngClass]="{'disabled': addToBagInProgress}" (click)="goToCustomerSelector()">
	<!-- <h6 class="ellipsis" [title]="'CUSTOMERS.BAR.ORDER-FOR' | translate: { 'name': '\n' + customerName }" [innerHTML]="'CUSTOMERS.BAR.ORDER-FOR' | translate {'name': ('<span>' + customerName + '</span>')}"></h6> -->
	<h6 class="ellipsis">
		{{('CUSTOMERS.BAR.ORDER-FOR' | translate) + ' ' + customerName}}

	</h6>

	<i class="fa-light fa-arrow-right-arrow-left"></i>
</div>
}